import React from 'react';
import { Box } from '@mui/material';
import { DateObject } from '@uplift/services';
import { TimeRange } from '@uplift/types';
import { Modal } from '../../../Modal';
import { Loader } from '../../../Loader';
import { CalendarPicker } from './CalendarPicker.component';
import { AvailabilityForm } from './AvailabilityForm.component';
import { AvailabilityFormButtons } from './AvailabilityFormButtons.component';


export type AvailabilityFormModalProps = {
  open: boolean;
  handleClose: () => void;
  handleClosed?: () => void;
  title: string;
  date?: DateObject;
  onDateSelect?: (date: DateObject) => void;
  warningOnLessThenHour?: boolean;
  defaultAvailability?: TimeRange[];
  prepend?: React.ReactNode;
  today?: DateObject;
  loading?: boolean;
  isAddingOverride?: boolean;
};


export type AvailabilityFormModalBodyProps = Omit<AvailabilityFormModalProps, 'open' | 'title'>;


export const AvailabilityFormModalBody: React.FC<AvailabilityFormModalBodyProps> = (props) => {
  return (
    <Box display="flex" alignItems="space-between" borderTop="1px solid rgba(0, 0, 0, 0.1)">
      {props.date && props.onDateSelect && (
        <Box p={3} pt={1}>
          <Box width="248px" overflow="hidden">
            <CalendarPicker
              disablePast
              today={props.today}
              date={props.date}
              onDateSelect={props.onDateSelect}
            />
          </Box>
        </Box>
      )}
      <Box p={3} width="420px" display="flex" flexDirection="column" flex="1" justifyContent="space-between">
        <Box pb={2}>
          {props.prepend}
          {props.loading ? (
            <Box height="100%">
              <Loader />
            </Box>
          ) : (
            <Box maxHeight="296px" overflow="auto">
              <AvailabilityForm warningOnLessThenHour={props.warningOnLessThenHour} />
            </Box>
          )}
        </Box>
        <Box pt={2}>
          <AvailabilityFormButtons
            loading={props.loading}
            handleClose={props.handleClose}
            isAddingOverride={props.isAddingOverride}
            defaultAvailability={props.defaultAvailability}
          />
        </Box>
      </Box>
    </Box>
  );
};


export const AvailabilityFormModal: React.FC<AvailabilityFormModalProps> = (props) => {
  return (
    <Modal open={props.open} onClose={props.handleClose} title={props.title} maxWidth={false} onExited={props.handleClosed}>
      <AvailabilityFormModalBody {...props} />
    </Modal>
  );
};
